import { render, staticRenderFns } from "./RequestTypeConfig.vue?vue&type=template&id=b6db5a8a&scoped=true&"
import script from "./RequestTypeConfig.vue?vue&type=script&lang=js&"
export * from "./RequestTypeConfig.vue?vue&type=script&lang=js&"
import style0 from "./RequestTypeConfig.vue?vue&type=style&index=0&id=b6db5a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6db5a8a",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/RequestTypeTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fcbs%2Frequest-types%2FRequestTypeConfig.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports